import { RemoteI9Details } from '@dtos/remote-i9-details';
import { IOnboardingDetailsRequestService } from '@services/onboarding-review/onboarding-details-request-service';
import { ISection1PreparerTranslatorStore } from '@stores/onboarding-review/section1-preparer-translator-store';
import { Subscription } from 'rxjs';

export interface ISection1PreparerTranslatorUpdater {
    initialise(): void;
    cleanup(): void;
}

const emptyTranslatorPreparerFields = {
    apartmentNumber: '',
    city: '',
    didUseTranslatorPreparer: false,
    firstName: '',
    lastName: '',
    signature: '',
    signedOn: '',
    state: '',
    streetAddress: '',
    zipCode: ''
};

/**
 * Logic layer entity that responds to onboarding details request events for preparer translator store
 */
export class Section1PreparerTranslatorUpdater implements ISection1PreparerTranslatorUpdater {
    private subscriptions: Subscription = Subscription.EMPTY;

    constructor(
        private store: ISection1PreparerTranslatorStore,
        private onboardingDetailsRequestService: IOnboardingDetailsRequestService
    ) {
    }

    initialise() {
        this.subscriptions = this.onboardingDetailsRequestService
            .requestEvents
            .subscribe(event => {
                if (event.type === 'pending') {
                    this.handlePending();
                    return;
                }

                if (event.type === 'success') {
                    this.handleSuccess(event.dto);
                    return;
                }
            })
    }

    cleanup() {
        this.subscriptions.unsubscribe();
    }

    handlePending = () => {
        this.store.setDetails(emptyTranslatorPreparerFields);
    };

    handleSuccess = ({ translatorDetails }: RemoteI9Details) => {
        if (!translatorDetails.translatorUsed) {
            this.store.setDetails({
                ...emptyTranslatorPreparerFields,
                didUseTranslatorPreparer: translatorDetails.translatorUsed
            });
            return;
        }

        this.store.setDetails({
            apartmentNumber: translatorDetails.address.apartmentNumber,
            city: translatorDetails.address.city,
            state: translatorDetails.address.state,
            streetAddress: translatorDetails.address.streetAddress,
            zipCode: translatorDetails.address.zipCode,
            didUseTranslatorPreparer: translatorDetails.translatorUsed,
            firstName: translatorDetails.firstName,
            lastName: translatorDetails.lastName,
            signature: translatorDetails.signature,
            signedOn: translatorDetails.signedOn
        });
    };
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section1-preparer-translator-updater.ts